import Vue from 'vue';

// 通过Vue.observable创建一个可响应的对象
export const store = Vue.observable({
  hasRoute: false,
});

// 定义 mutations, 修改属性
export const mutations = {
  setHasRoute(hasRoute) {
    store.hasRoute = hasRoute;
  }
};



// WEBPACK FOOTER //
// ./src/store/index.js